import Swiper from 'swiper';

// Swiper Content Block slider
const init = function(swiperId) {
  const arrows = document.querySelector('.js-swiper-content-block-arrows');
  const pagination = document.querySelector(
    '.js-swiper-content-block-pagination'
  );
  const contentBlockSwiper = new Swiper(swiperId, {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    grabCursor: true,
    watchSlidesProgress: true,
    spaceBetween: 30,
    lazy: true,
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: '.js-swiper-content-block-pagination',
      clickable: true,
    },
    on: {
      init: function() {
        const swiper = this;
        if (swiper.slides.length <= 1) {
          addClass(arrows, 'hidden');
          addClass(pagination, 'hidden');
        }
      },
    },
    navigation: {
      nextEl: '.js-swiper-button-next',
      prevEl: '.js-swiper-button-prev',
    },
  });
};

export default {
  init,
};
